var month = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ];
var date = new Date();
var currentMonth = month[date.getMonth()];

var sheetSet = {
	defaults: {
		selectedOptions: '',
		sheetItems: [],
		sheetItemsInventory: []
	},
	onInit: function() {
		var vm = this;
		var el = vm.defaults;

		vm.initSheetSet();
		vm.onVariantSelectChange();
		vm.addSheetItems();
		vm.collectionAddSheetSet();

		var prod_id = '';
		var variant_id = '';
		if ($('#ProductSelect-product-template').length > 0) {
			prod_id = $('#ProductSelect-product-template').parent().attr('prodid');
			variant_id = $('#ProductSelect-product-template').val();
		}
		vm.getSelectData(prod_id, variant_id);
	},
	onLoad: function() {
		var vm = this;
		var el = vm.defaults;

		prod_id = $('#ProductSelect-product-template').parent().attr('prodid');
		if (el.sheetItemsInventory.length > 0) {
			vm.checkSheetSetInclusions(prod_id);
		}
	},
	onResize: function() {
		var vm = this;
		var el = vm.defaults;
	},
	initSheetSet: function() {
		var vm = this;
		var el = vm.defaults;
	},
	onVariantSelectChange: function() {
		var vm = this;
		var el = vm.defaults;

		$('.selector-wrapper select').on('change', function() {
			var prod_id = '';
			var variant_id = '';
			if ($('#ProductSelect-product-template').length > 0) {
				prod_id = $('#ProductSelect-product-template').parent().attr('prodid');
				variant_id = $('#ProductSelect-product-template').val();
			}
			vm.getSelectData(prod_id, variant_id);
		});
	},
	checkSheetSetInclusions: function(prod_id) {
		var vm = this;
		var el = vm.defaults;

		if (parseInt(el.sheetItemsInventory[0]['inventory']) <= 0 && el.sheetItemsInventory[0]['availability'] == 'true' ||
			parseInt(el.sheetItemsInventory[1]['inventory']) <= 0 && el.sheetItemsInventory[1]['availability'] == 'true' ||
			parseInt(el.sheetItemsInventory[2]['inventory']) <= 0 && el.sheetItemsInventory[2]['availability'] == 'true' ) {
			setTimeout(function() {
				$('#AddToCart-product-template').text('Pre-order Now');
				jQuery('.product-status').html('Available on Pre-Order');

				var preorder_message = $('.preorder-text').text();
				var preorder_delivery = sheetSetDelivery(el.sheetItemsInventory[0]['delivery'],el.sheetItemsInventory[1]['delivery'],el.sheetItemsInventory[2]['delivery']);
				if ( preorder_delivery != '' ) {
					preorder_message += 'for ' +preorder_delivery+ ' delivery';
				}
				$('.preorder-notice p').text(preorder_message);
				$('.preorder-notice').show();
				jQuery('.product-form__cart-submit').prop('disabled', false);
			}, 300);
			$('form[data-prodid="'+prod_id+'"] .quick-addtocart-button .add-sheet-set').val('Pre-order Now');
		} else {
			setTimeout(function() {
				$('.preorder-notice').hide();
				$('#AddToCart-product-template').text('Add to Cart');
				jQuery('.product-status').html('In Stock');
				jQuery('.product-form__cart-submit').prop('disabled', false);
			}, 300);
			$('form[data-prodid="'+prod_id+'"] .quick-addtocart-button .add-sheet-set').val('Add to Cart');
		}
	},
	getSelectedVariantColour: function() {
		var vm = this;
		var el = vm.defaults;

		var variantColour = $('#SingleOptionSelector-0').val();
		return variantColour;
	},
	getSelectedVariantSize: function() {
		var vm = this;
		var el = vm.defaults;

		$('.product-form .selector-wrapper').each(function() {
			if ($(this).next('.selector-wrapper').length > 0 ) {
				el.selectedOptions += $(this).find('select').val() + ' / ';
			} else {
				el.selectedOptions += $(this).find('select').val();
			}
		});

		var variantSize = $('#SingleOptionSelector-1').val();
		return variantSize;
	},
	getSelectData: function(prod_id, variant_id) {
		var vm = this;
		var el = vm.defaults;

		var variantColour = '';
		var variantSize = '';

		if ($('#ProductSelect-product-template').length > 0) {
			variantColour = vm.getSelectedVariantColour();
			variantSize = vm.getSelectedVariantSize();
		} else if ($('.quick-addtocart-wrapper').length > 0) {
			variantSize = $('#product-select-'+prod_id+' option[value="'+variant_id+'"]').attr('data-option2');
			variantColour = $('#product-select-'+prod_id+' option[value="'+variant_id+'"]').attr('data-option1');
		}

		if (variantSize == 'Twin') {
			var includePillow = $('.sheet-set-row[data-setid="'+prod_id+'"] .select-pillowcase').eq(0);
			var includeFitSheet = $('.sheet-set-row[data-setid="'+prod_id+'"] .select-fitsheet[data-vartitle="'+variantColour+' / Twin / Fitted Sheet"]');
			var includeFlatSheet = $('.sheet-set-row[data-setid="'+prod_id+'"] .select-flatsheet[data-vartitle="'+variantColour+' / Twin/Twin XL / Flat Sheet"]');

			setData(includePillow, includeFitSheet, includeFlatSheet);

		} else if (variantSize == 'Full') {
			var includePillow = $('.sheet-set-row[data-setid="'+prod_id+'"] .select-pillowcase').eq(0);
			var includeFitSheet = $('.sheet-set-row[data-setid="'+prod_id+'"] .select-fitsheet[data-vartitle="'+variantColour+' / Full / Fitted Sheet"]');
			var includeFlatSheet = $('.sheet-set-row[data-setid="'+prod_id+'"] .select-flatsheet[data-vartitle="'+variantColour+' / Full/Queen / Flat Sheet"]');

			setData(includePillow, includeFitSheet, includeFlatSheet);

		} else if (/Full Special/i.test(variantSize)) {
			var includePillow = $('.sheet-set-row[data-setid="'+prod_id+'"] .select-pillowcase').eq(0);
			var includeFitSheet = $('.sheet-set-row[data-setid="'+prod_id+'"] .select-fitsheet[data-vartitle="'+variantColour+' / Full / Fitted Sheet"]');
			var includeFlatSheet = $('.sheet-set-row[data-setid="'+prod_id+'"] .select-flatsheet[data-vartitle="'+variantColour+' / Full/Queen / Flat Sheet"]');

			setData(includePillow, includeFitSheet, includeFlatSheet);
		} else if (/Queen Special/i.test(variantSize)) {
			var includePillow = $('.sheet-set-row[data-setid="'+prod_id+'"] .select-pillowcase').eq(0);
			var includeFitSheet = $('.sheet-set-row[data-setid="'+prod_id+'"] .select-fitsheet[data-vartitle="'+variantColour+' / Queen / Fitted Sheet"]');
			var includeFlatSheet = $('.sheet-set-row[data-setid="'+prod_id+'"] .select-flatsheet[data-vartitle="'+variantColour+' / King/Cali King / Flat Sheet"]');

			setData(includePillow, includeFitSheet, includeFlatSheet);
		} else if (variantSize == 'Twin XL') {
			var includePillow = $('.sheet-set-row[data-setid="'+prod_id+'"] .select-pillowcase').eq(0);
			var includeFitSheet = $('.sheet-set-row[data-setid="'+prod_id+'"] .select-fitsheet[data-vartitle="'+variantColour+' / Twin XL / Fitted Sheet"]');
			var includeFlatSheet = $('.sheet-set-row[data-setid="'+prod_id+'"] .select-flatsheet[data-vartitle="'+variantColour+' / Twin/Twin XL / Flat Sheet"]');

			setData(includePillow, includeFitSheet, includeFlatSheet);

		} else if (/King Special/i.test(variantSize)) {
				var includePillow = $('.sheet-set-row[data-setid="'+prod_id+'"] .select-pillowcase').eq(0);
				var includeFitSheet = $('.sheet-set-row[data-setid="'+prod_id+'"] .select-fitsheet[data-vartitle="'+variantColour+' / King / Fitted Sheet"]');
				var includeFlatSheet = $('.sheet-set-row[data-setid="'+prod_id+'"] .select-flatsheet[data-vartitle="'+variantColour+' / King/Cali King / Flat Sheet"]');

				setData(includePillow, includeFitSheet, includeFlatSheet);
		} else if (/Cali King/i.test(variantSize)) {
				var includePillow = $('.sheet-set-row[data-setid="'+prod_id+'"] .select-k-pillowcase').eq(0);
				var includeFitSheet = $('.sheet-set-row[data-setid="'+prod_id+'"] .select-fitsheet[data-vartitle="'+variantColour+' / King / Fitted Sheet"]');
				var includeFlatSheet = $('.sheet-set-row[data-setid="'+prod_id+'"] .select-flatsheet[data-vartitle="'+variantColour+' / King/Cali King / Flat Sheet"]');

				setData(includePillow, includeFitSheet, includeFlatSheet);
		} else if (variantSize == 'Queen') {
			var includePillow = $('.sheet-set-row[data-setid="'+prod_id+'"] .select-pillowcase').eq(0);
			var includeFitSheet = $('.sheet-set-row[data-setid="'+prod_id+'"] .select-fitsheet[data-vartitle="'+variantColour+' / Queen / Fitted Sheet"]');
			var includeFlatSheet = $('.sheet-set-row[data-setid="'+prod_id+'"] .select-flatsheet[data-vartitle="'+variantColour+' / Full/Queen / Flat Sheet"]');

			setData(includePillow, includeFitSheet, includeFlatSheet);
		} else if (variantSize == 'King') {
			var includePillow = $('.sheet-set-row[data-setid="'+prod_id+'"] .select-k-pillowcase').eq(0);
			var includeFitSheet = $('.sheet-set-row[data-setid="'+prod_id+'"] .select-fitsheet[data-vartitle="'+variantColour+' / King / Fitted Sheet"]');
			var includeFlatSheet = $('.sheet-set-row[data-setid="'+prod_id+'"] .select-flatsheet[data-vartitle="'+variantColour+' / King/Cali King / Flat Sheet"]');

			setData(includePillow, includeFitSheet, includeFlatSheet);
		}

		function setData(includePillow, includeFitSheet, includeFlatSheet) {
			$('.sheet-set-row[data-setid="'+prod_id+'"] .selected-pillowcase').attr('data-varid', includePillow.attr('data-varid'));
			$('.sheet-set-row[data-setid="'+prod_id+'"] .selected-pillowcase').text(includePillow.attr('data-vartitle'));

			$('.sheet-set-row[data-setid="'+prod_id+'"] .selected-fitsheet').attr('data-varid', includeFitSheet.attr('data-varid'));
			$('.sheet-set-row[data-setid="'+prod_id+'"] .selected-fitsheet').text(includeFitSheet.attr('data-vartitle'));

			$('.sheet-set-row[data-setid="'+prod_id+'"] .selected-flatsheet').attr('data-varid', includeFlatSheet.attr('data-varid'));
			$('.sheet-set-row[data-setid="'+prod_id+'"] .selected-flatsheet').text(includeFlatSheet.attr('data-vartitle'));
		}



		$('.sheet-set-row[data-setid="'+prod_id+'"] .selected-set').each(function(index) {
			var sheetitem = $(this).attr('data-varid');
			var prodid = $('.select-source[data-varid="'+sheetitem+'"]').attr('data-prodid');
			el.sheetItems.push(sheetitem);
			if (el.sheetItems.length > 0) {
				var inventory = $('.sheet-set-data-wrapper li[data-varid="'+sheetitem+'"]').attr('data-inventory');
				var availability = $('.sheet-set-data-wrapper li[data-varid="'+sheetitem+'"]').attr('data-availability');
				el.sheetItemsInventory[index] = {'inventory': inventory, 'availability': availability};
				el.sheetItemsInventory[index].id = sheetitem;
				if ( inventory <= 0 && availability == 'true' ) {
					el.sheetItemsInventory[index].delivery = getItemDelivery(sheetitem);
				} else {
					el.sheetItemsInventory[index].delivery = '';
				}

				// console.log(prodid);
				// console.log(sheetitem);
				// console.log(inventory);
				// setTimeout(function() {
					if (inventory <= 0 ){
							//jQuery('.variant-error').text('Please Select Size');
							jQuery('.product-back-instock-subscribe-from').removeClass('hide-backinstock');
							jQuery('#BISform input#BISvariantid').val(sheetitem);
							jQuery('#BISform input#BISproductid').val(prodid);
					} else {
							jQuery('.variant-error').text('');
							jQuery('.product-back-instock-subscribe-from').addClass('hide-backinstock');
					}
				// },300);
			}
		});
		if (el.sheetItems.length > 0) {
			vm.checkSheetSetInclusions(prod_id);
		}
	},
	addSheetItems: function() {
		var vm = this;
		var el = vm.defaults;

		var prod_id = '';
		var sheetsetBtn = document.getElementById('AddToCart-product-template');
		if ($('#AddToCart-product-template').length > 0) {
			sheetsetBtn.addEventListener('click', function(e) {
				if ($('#ProductSelect-product-template').length > 0) {
					prod_id = $('#ProductSelect-product-template').parent().attr('prodid');
				}
				if ($('.sheet-set-row[data-setid="'+prod_id+'"] .set-inclusions-wrapper').length > 0) {
					e.preventDefault();
					$('.product-form__item.product-form__item--submit').addClass('loading');
					setTimeout(function() {
						vm.ajaxAddSheetSet(prod_id);
					}, 100);
				}
			});
		}
	},
	collectionAddSheetSet: function() {
		var vm = this;
		var el = vm.defaults;

		$('.add-sheet-set').on('click', function(e) {
			e.preventDefault();
			$(this).parent().addClass('loading');
			var form = $(this).closest('form');
			var prod_id = form.attr('data-prodid');
			setTimeout(function() {
				vm.ajaxAddSheetSet(prod_id);
			}, 100);
		});
	},
	ajaxAddSheetSet: function(prod_id) {
		var vm = this;
		var el = vm.defaults;

		var lineKeys = [];
		var lineQuantities = [];

		if ($('#ProductSelect-product-template').length > 0) {
			var setId = $('#ProductSelect-product-template').val();
		} else {
			var setId = $('#product-select-'+prod_id).val();
		}
		if ($('#Quantity-product-template').length > 0) {
			var setQuantity = $('#Quantity-product-template').val();
		} else {
			var setQuantity = 1;
		}
		var preorder = false;
		$('.sheet-set-row[data-setid="'+prod_id+'"] .set-inclusions-wrapper .selected-set').each(function() {
			var thisProductId = $(this).attr('data-varid');
			var inventory = $('.sheet-set-row[data-setid="'+prod_id+'"] .sheet-set-data-wrapper li[data-varid="'+thisProductId+'"]').attr('data-inventory');
			var availability = $('.sheet-set-row[data-setid="'+prod_id+'"] .sheet-set-data-wrapper li[data-varid="'+thisProductId+'"]').attr('data-availability');
			var setData = {};
			if (parseInt(inventory) <= 0 && availability == 'true') {
				preorder = true;
				setData = {
					quantity: setQuantity,
					id: thisProductId,
					properties: {
						"SheetSet": setId,
						// "PreOrder": 'Available On Backorder'
					}
				}
			} else {
				setData = {
					quantity: setQuantity,
					id: thisProductId,
					properties: {
						"SheetSet": setId
					}
				}
			}
			$.ajax({
				type: 'POST',
				url: '/cart/add.js',
				dataType: 'json',
				data: setData,
				async: false,
				beforeSend: function() {
				},
				success: function(data) {
					// console.log(data);
					var lineKey = data.key;
					var lineQuant = data.quantity;
					// UPDATE TOTAL CART DRAWER
					// console.log('added item '+ thisProductId);
					lineKeys.push(lineKey);
					lineQuantities.push(lineQuant);
					// vm.ajaxAddCart(setId, parentLineKey, lineKeys, lineQuantities, parentLineImage, parentLineUrl, parentLineTitle);
				},
				error: function() {
					// console.log('no item added');
				}
			}); // END AJAX ADD TO CART
			if ($(this).index() == ($('.sheet-set-row[data-setid="'+prod_id+'"] .set-inclusions-wrapper .selected-set').length - 1) ) {
				addSheetParent(setId, preorder);
			}
		});
		function addSheetParent(setId, preorder) {
			var property = {
						"ParentSheet": setId
			};
			if (preorder) {
				var preorder_delivery = sheetSetDelivery(el.sheetItemsInventory[0]['delivery'],el.sheetItemsInventory[1]['delivery'],el.sheetItemsInventory[2]['delivery']);
				//console.log(preorder_delivery);
				property.PreOrder = 'Available On Backorder - '+preorder_delivery+' delivery.'
			}
			$.ajax({
				type: 'POST',
				url: '/cart/add.js',
				dataType: 'json',
				data: {
					quantity: setQuantity,
					id: setId,
					properties: property,
				},
				async: false,
				beforeSend: function(data) {
					// console.log(data)
				},
				success: function(data) {
					// console.log(data);
					// UPDATE TOTAL CART DRAWER
					var parentLineKey = data.key;
					var parentLineImage = data.image;
					var parentLineUrl = data.url;
					var parentLineTitle = data.title;
					updateCartDrawer();
					//showCartDrawer();
					bundleAdded();
					setTimeout(function() {
						$('.product-form__item.product-form__item--submit').removeClass('loading');
						$('.quick-addtocart-button.loading').removeClass('loading');
					}, 280);
				},
				error: function() {
					// console.log('no item added');
				}
			}); // END AJAX ADD TO CART
		}
	}
}

function getItemDelivery (variantId) {
	var delivery = '';
	if ( pn.settings.singleProductSettings.length ) {
		pn.settings.singleProductSettings.forEach(function(element) {
		if ( element.n == variantId ) {
			delivery = element.g;
			return 0;
		}
	});
	}
	if ( typeof(pn.settings.defaultSetting) != null && delivery == '' ) {
		return pn.settings.defaultSetting.g;
	}
	return delivery;
}

function sheetSetDelivery (month1, month2, month3) {
	var date = new Date();
	var currentMonth = month[date.getMonth()];
	var current = date.getMonth();
	var mon = [month1, month2, month3];
	var monFilter = [];
	var monNum = [];

	mon.forEach(function(element) {
		if ( element != '' ) {
			monFilter.push(element);
		}
	});
	monFilter.forEach(function(element) {
		monNum.push(month.indexOf(element)>=0?month.indexOf(element):current);
	});
	var diff = [];
	monNum.forEach(function(element) {
		var a = element-current>=0?element-current:element-current+12;
		diff.push(a);
	});
	// console.log(monFilter);
	// console.log(monNum);
	// console.log(diff);
	var index = diff.indexOf(Math.max.apply(Math,diff));
	return monFilter[index];
}
$(window).on('load', function() {
	sheetSet.onLoad();
});